import React, { useEffect, useState } from 'react';
import { Box, Text, VStack, Link } from '@chakra-ui/react';

export default function Toc({ headings }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!headings.length) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-80px 0px -72% 0px' }
    );
    headings.forEach((h) => {
      const el = document.getElementById(h.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [headings]);

  if (!headings.length) return null;

  return (
    <Box as="nav" aria-label="이 페이지 목차" display={{ base: 'none', xl: 'block' }}
      position="sticky" top="76px" w="196px" flexShrink={0} maxH="calc(100dvh - 96px)" overflowY="auto">
      <Text fontSize="10.5px" fontWeight="600" letterSpacing="0.11em" textTransform="uppercase" color="neutral.500" mb={3}>
        이 페이지
      </Text>
      <VStack align="stretch" spacing={0.5}>
        {headings.map((h) => (
          <Link key={h.id} href={`#${h.id}`} fontSize="12.5px" lineHeight="1.5" py={1} pl={3}
            borderLeftWidth="2px" _hover={{ textDecoration: 'none', color: 'neutral.700' }}
            borderLeftColor={active === h.id ? 'brand.500' : 'neutral.200'}
            color={active === h.id ? 'brand.700' : 'neutral.500'}
            fontWeight={active === h.id ? '600' : '400'}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(h.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          >
            {h.title}
          </Link>
        ))}
      </VStack>
    </Box>
  );
}
